import React from "react";
import PropTypes from "prop-types";
import Fade from "@material-ui/core/Fade";
import Transition from "../../components/Transition";
import Block from "./Block";
import MainRing from "../Page/MainRing";
import OuterRings from "../Page/OuterRings";
import StyleDots from "../Page/StyleDots";

export default function Page({ children, open }) {
  return (
    <>
      <Transition in component={Fade} timeout={3300}>
        <StyleDots />
      </Transition>
      {[0, 0.125, 0.75, 1.5, 2.75].map(delay => (
        <OuterRings key={delay} delay={delay} open={open} />
      ))}
      <MainRing open={open} />
      <Transition in component={Fade} delay={775} timeout={775}>
        <Block>{children}</Block>
      </Transition>
    </>
  );
}

Page.propTypes = {
  children: PropTypes.node.isRequired,
  open: PropTypes.bool
};

Page.defaultProps = {
  open: false
};
